import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=5d3815e9&scoped=true"
import script from "./RoleModal.vue?vue&type=script&lang=js"
export * from "./RoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3815e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3815e9')) {
      api.createRecord('5d3815e9', component.options)
    } else {
      api.reload('5d3815e9', component.options)
    }
    module.hot.accept("./RoleModal.vue?vue&type=template&id=5d3815e9&scoped=true", function () {
      api.rerender('5d3815e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/RoleModal.vue"
export default component.exports